import { async } from "@firebase/util";
import { GoogleMap, MarkerF, useLoadScript, CircleF, MarkerClustererF, DirectionsRenderer, DistanceMatrixService} from "@react-google-maps/api";
import { useState, useEffect } from "react";
import AddNewButton from "../Buttons/AddNewButton";
import { useMemo } from "react";
import { db } from "../../firebase";
import { ref, set, update, push, child, get, onValue } from "firebase/database";



const RouteMapView = (props) => {
  const [directions, setDirections] = useState();
  const [bins, setBins] = useState([]);
  const [filledBins, setFilledBins] = useState([]);
  const [workers, setWorkers] = useState();
  const [newRouteData, setNewRouteData] = useState({
      "name": "Route 3",
      "directions": "",
      "distance":"",
      "duration":"",
      "startDate": "",
      "endDate": "",
      "assignedBins": {},
      "assignedWorker": ""
    });
  // const [newRouteData, setNewRouteData] = useState({
  //   "name": "Route 3",
  //   "description": "Description of Route 3",
  //   "origin": '',
  //   "waypoints": {
  //       "waypoint1": {
  //           "name": "street 12, Galyat",
  //           "latitude": 123.456,
  //           "longitude": 789.012
  //       },
  //       "waypoint2": {
  //           "name": "street 13, Galyat",
  //           "latitude": 345.678,
  //           "longitude": 901.234
  //       },
        
  //   },
  //   "startDate": "2023-05-30",
  //   "endDate": "2023-06-10",
  //   "duration":"",
  //   "distance":"",
  //   "assignedBins": {
  //       "bin4": true,
  //       "bin3": true,  
  //   },
  //   "assignedWorker": "worker1"
  // });

  let duration;
  let distance;
  var google = window.google;

  const origin = useMemo(() => ({ lat: 33.14897965904864, lng: 73.731568201737 }), []);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  });

  

  const options = useMemo(() => ({
    mapId:'b8f83238d876673f',
    disableDefaultUI: true,
    clickableIcons: false,
  }), []);


  const updatedAssignedBins = {
    ...newRouteData.assignedBins, // Copy existing assignedBins
    binId1: true, // Add a new bin ID with the desired boolean value (e.g., true)
    binId2: true, // Add another bin ID with the desired boolean value
    // Add more bin IDs as needed
  };




  //   Get bin Data
  useEffect(() => {
    const fetchBins = async () => {
    try {
      const binRefrence = await ref(db, 'bins');
      onValue(binRefrence, (snapshot) => {

        if ((snapshot).exists) {
          const binsData = (snapshot).val();
          const binsArray = Object.entries(binsData).map(([binId, bin]) => ({
              id: binId,
              ...bin,
          }));
          const filledBins = Object.values(binsData).filter(bin => bin.capacity >= 45);

          // Add Assigned Bins
          const assignedBins = {};
          binsArray?.forEach(bin =>{
            if (bin.capacity >= 45){
              assignedBins[bin.id] = true;
            }
          })

          setNewRouteData((prevData) => ({
            ...prevData,
            assignedBins: assignedBins,
          }))

          setFilledBins(filledBins);
          setBins(binsArray.reverse());
        

        }
      })
    } catch (error) {
        console.error('Error retrieving bins:', error);
        
    }
    };

    fetchBins();
  }, []);


  // Fetch workers
  useEffect(()=> {
    const fetchWorkers = async ()=>{
      try {
        const workersRef = await ref(db, 'workers');
        const snapshot = get(workersRef);
        if ((await snapshot).exists) {
          const workersData = (await snapshot).val();
          const workersArray = Object.entries(workersData).map(([workerId, worker]) => ({
            id: workerId,
            ...worker,
            assigned: false, // Add an 'assigned' property to track assignment status
          }));
          
          // choose available workers
          const availableWorkers = workersArray.filter(worker => !worker.assignedRoute.IsAssigned && worker.status === 'active');
          console.log('available workers ==>', availableWorkers);
          if(availableWorkers.length > 0){
            const chosenWorker = availableWorkers[0];
            setNewRouteData(prevData => ({
              ...prevData,
              assignedWorker: chosenWorker.id,
            }))
            
          }
          // Set the list of available workers in state
          setWorkers(availableWorkers);
        }
      } catch (error) {
        console.error('Error retrieving workers:', error);
      }
    }

      fetchWorkers();
    

  }, [])
 


  console.log('Route with bin ids ===>', newRouteData.assignedWorker)
  // console.log('workers ==>', workers)


  
  // All Bins Marks
  const allBinsMarks = bins?.map((mark, index) => ({
    location: google && new google.maps.LatLng(mark.coOrdinates.latitude, mark.coOrdinates.longitude),
    stopover: true,  
  })).reverse();

  

  // waypoints
  const waypoints = filledBins?.map((mark, index) => ({
    location: google && new google.maps.LatLng(mark.coOrdinates.latitude, mark.coOrdinates.longitude),
    stopover: true,  
  })).reverse();
  
  // console.log('Filled Bins ===>',filledBins)
  
  // fetch Directions
  const fetchDirections = async (markLoc) => {
    if (!origin) return;
    const service = google && await new google.maps.DirectionsService();
    console.log('works here')
    try{
      await service.route(
        {
          origin: origin,
          destination: markLoc,
          waypoints:waypoints,
          travelMode: google?.maps.TravelMode.DRIVING,
          provideRouteAlternatives: true,
          optimizeWaypoints: true,
          avoidFerries: false,
          avoidHighways: false,
          avoidTolls: false,
        },
        (result, status) => {
          if (status === "OK" && result) {
            setDirections(result);
            console.log(result);
          }
        },    
      );
    } catch (error){
      console.error("Error creating route: ", error);
      alert("Error Creating route: ", error);
    };
  };


  // Handle New Route Data
  const handleChange = (event) => {
    const { name, value } = event.target;    
    setNewRouteData((prevData) => ({ 
        ...prevData,
        [name]: value,
    }));
  };



  const handleSubmit = (event) => {
    event.preventDefault();
    if (directions == undefined){
      alert('create Route First')
    } else {    
      distance = calculateDistance(directions);
      duration = calculateTotalDuration(directions);
      console.log(`Distance: ${distance}  Duration: ${duration}`);
      // const currentTime = new Date().toLocaleString();
      var today = new Date(),
      currentTime = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();

      var tomorrow = new Date(currentTime)
      tomorrow.setDate(tomorrow.getDate()+1).toLocaleString()
      var endDate = tomorrow.getFullYear() + '-' + (tomorrow.getMonth() + 1) + '-' + tomorrow.getDate();

      const routeId = push(child(ref(db), 'routes')).key;
      const routeData = {
        [routeId]: {
            "name": newRouteData.name,
            "directions": JSON.parse(JSON.stringify(directions)),
            "distance": distance,
            "duration": duration,
            "startDate": currentTime,
            "endDate": endDate,
            "assignedBins": newRouteData.assignedBins,
            "assignedWorker": newRouteData.assignedWorker
          
        },
      };

      if(newRouteData.assignedWorker === ''){
        alert('No collector available')
      } else {
        const newRoutesRef = ref(db, 'routes/');
        update(newRoutesRef, routeData)
        .then(()=>{
            console.log(routeData)
            update(ref(db, `workers/${newRouteData.assignedWorker}/`), {
                assignedRoute:{
                  IsAssigned: true,
                  assignedRouteId: [routeId],
                }
              
            });
            // const collRef = ref(db, 'workers/' + newRouteData.assignedWorker);
  
            alert('route is registered');
            // Clear the form
            setNewRouteData({
                "name": "Route 1",
                "direction": "",
                "distance":"",
                "duration":"",
                "startDate": "",
                "endDate": "",
                "assignedBins": {},
                "assignedWorker": "",
          });
          
          console.log('success: data is generated')
          
        })
      }
    }

  }


  // Calculate Distance
  const calculateDistance =  (direction) =>{
    const legs = direction.routes[0].legs;
    let totalDistance = 0;
    let totalDistancekm = 0
    for(let i = 0; i < legs.length; i++){
      totalDistance += legs[i].distance.value;
    }

    totalDistancekm = totalDistance/1000;
    return totalDistancekm
    
  }


  // Calculate Time Taken
  const calculateTotalDuration = (direction) =>{
    const legs = direction.routes[0].legs;
    let totalTime = 0;
    let totalTimeMins = 0
    for(let i = 0; i < legs.length; i++){
      totalTime += legs[i].duration.value;
    }

    totalTimeMins = totalTime/60;

    return totalTimeMins
  }


  
  // Options for Circles
  const defaultOptions ={
    strokeOpacity: 0.5,
    strokeWeight: 2,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
  }

  const closeOptions={
    ...defaultOptions,
    zIndex:3,
    fillOpacity:0.05,
    strokeColor: "#88C34A",
    fillColor: "#88C34A",
  }

  const middleOptions={
    ...defaultOptions,
    zIndex:2,
    fillOpacity:0.05,
    strokeColor: "#FBC02D",
    fillColor: "#FBC02D",
  }

  const farOptions={
    ...defaultOptions,
    zIndex:1,
    fillOpacity:0.05,
    strokeColor: "#FF5252",
    fillColor: "#FF5252",
  }



  

  return (
    <>
      <div className="bg-gray-800 rounded-xl" style={{height: '390px'}}>

        
          <div id="Filter-routes" className="flex flex-row gap-x-5 justify-between p-2 items-center">
            <h5 className="text-white text-xl px-2.5 py-2.5 font-bold">Map View</h5>

            {/* Add New Route Button */}
            <div className="gap-2">
                <AddNewButton innerTxt={"+ Add New Route"} submitbtn={handleSubmit} />
            </div>
          
          </div>
      
        <div className="h-full">
          {!isLoaded ? (
            <h1>Loading...</h1>
          ):(
            <GoogleMap
              mapContainerClassName="map-container h-full rounded-lg"
              center={origin}
              zoom={12}
              options={options}
              
            >

              {directions && <DirectionsRenderer directions={directions} options={{
                polylineOptions: {zIndex: 50, strokeColor:'#1976D2', strokeWeight:5}
              }} /> }

              <MarkerF position={origin} icon={'images/Oval.png'} />
              {allBinsMarks.map((mark, index) => (<MarkerF key={index} position={mark.location} icon={'http://mt.googleapis.com/vt/icon/name=icons/spotlight/spotlight-poi.png'} /> ))}

              {waypoints.map((mark, index) => (<MarkerF key={index} position={mark.location} zIndex={'100'} icon={'http://www.google.com/intl/en_us/mapfiles/ms/micons/blue-dot.png'} onClick={() => {
                const destinationLoc = mark.location
                fetchDirections(destinationLoc);

                console.log(destinationLoc)
              }} /> ))}

              <CircleF center={origin} radius={5000} options={closeOptions} />
              <CircleF center={origin} radius={10000} options={middleOptions} />
              <CircleF center={origin} radius={15000} options={farOptions} />

              

            
                
            </GoogleMap>
          )}
        </div>
      </div>
    </>




  );
};



export default RouteMapView;
